module.exports = __webpack_public_path__ + "img/manufacturing.ed9b6cad.svg";